// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
/** @ngInject */
export function Controller(
    $scope,
    $state,
    $uibModal,
    Alert,
    EditProfileMainModal,
    RegistrationProfile,
) {
    this.$onInit = () => $scope.profile = this.profile;

    $scope.isFacebook = function(profile) {
        return profile.profileSource == "FACEBOOK";
    }
    
    $scope.isActiveDirectory = function(profile) {
        return profile.adAccountClone != null;
    }

    $scope.changeDefaultProfile = () => {
        RegistrationProfile
            .setDefault({id: this.profile.id}, this.profile.isDefault).$promise
            .then((profiles) => Object.assign(this.profiles, profiles))
    }

    $scope.editProfileMain = (profile) => {
        EditProfileMainModal(profile).then(editSuccess);
    };

    function editSuccess(profile) {
        Object.assign($scope.profile, profile);
        Alert('success', 'registration_profiles.messages.edit');
    }

    $scope.copy = function(profile) {
        RegistrationProfile.copyProfile({
            id : profile.id
        }, function(data) {
            Alert('success', 'registration_profiles.messages.copy');
        });
    }

    $scope.deleteProfile = (profile) => {
        $uibModal
            .open({component: 'deleteProfile', resolve: {profile: () => profile}}).result
            .then(() => {
                Alert('success', 'registration_profiles.messages.delete');
                $state.go('user.profiles', {}, {reload: true});
            });
    };
}



// WEBPACK FOOTER //
// ./src/portal/states/user/profiles/profile/main/main.controller.js